import React from 'react';
import { Link } from 'react-router-dom';
import { getImagePath } from '../helpers.js';

function GalleryListItem(props) {
  return (
    <div className="gallery-list-item">
      <Link to={`/${props.item.path}`}>
        <div className="img-wrap">
          <img src={getImagePath(props.item.images[0], props.item.image_key, "small")}/>
          <div className="overlay"><div className="title">{props.item.title}</div></div>
        </div>
      </Link>
    </div>
  );
}

export default GalleryListItem;